import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Attendee} from "../model/attendee.model";
import {retryAfterMillis} from "../shared/constants";
import {utf8Decode} from "sdv-common";

@Injectable({providedIn: 'root'})
export class AttendeeService {

  private attendees: Attendee[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('attendees')
      .subscribe(response => {
        const attendees: Attendee[] = [];
        for (const attendee of response) {
          attendees.push(this.covertAttendee(attendee));
        }
        this.attendees = attendees;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  private covertAttendee(attendee) {
    return {
      id: utf8Decode(attendee.id || ''),
      name: utf8Decode(attendee.name || '')
    };
  }

  get(limit, offset) {
    return this.attendees;
  }
}
